export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const SET_ITEM_DISCOUNT = 'SET_ITEM_DISCOUNT'
